import { render } from "./TranslateButton.vue?vue&type=template&id=b99aa9f0&scoped=true&lang=pug"
import script from "./TranslateButton.vue?vue&type=script&lang=js"
export * from "./TranslateButton.vue?vue&type=script&lang=js"

import "./TranslateButton.vue?vue&type=style&index=0&id=b99aa9f0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99aa9f0"]])

export default __exports__